import { FC } from 'react';
import { PrismicNextLink } from '@prismicio/next';
import { HeaderDocument } from '../../../../../prismicio-types';
import { IconTimer } from '@/assets';
import { Button } from '@/components';
import NextButton from '@/components/Button/NextButton';
import { MODAL_NAMES } from '@/constants/modals';
import useModal from '@/hooks/useModal';
import { ProspectData } from '@/types/salesforce';
import styles from './LandingPageContent.module.scss';

type Props = {
  page: HeaderDocument<string>;
  isPreQualifiedPage: boolean;
  isEngineLanding: boolean;
  prospect?: ProspectData | null;
};

export const LandingPageContent: FC<Props> = ({
  page,
  isPreQualifiedPage,
  isEngineLanding,
  prospect,
}) => {
  const { openModal } = useModal();
  if (isPreQualifiedPage) {
    return (
      <>
        <div
          onClick={() => openModal({ name: MODAL_NAMES.preQualified })}
          className={styles.getInstantWrapper}
        >
          <IconTimer />
          <p className={styles.getInstantText}>
            Get instant offers in under 60 seconds
          </p>
        </div>
        <div className={styles.button_container}>
          <NextButton
            variation="primary"
            text="Get started now"
            type="button"
            styles={styles.button}
            onClick={() => openModal({ name: MODAL_NAMES.preQualified })}
          />
        </div>
      </>
    );
  }

  if (isEngineLanding) {
    return (
      <div className={styles.wrapper}>
        <div
          onClick={() =>
            openModal({
              name: MODAL_NAMES.engine,
              data: { prospect: prospect || null },
            })
          }
          className={styles.getInstantWrapper}
          style={{ cursor: 'pointer' }}
        >
          <IconTimer />
          <p className={styles.getInstantText}>
            Nice work! The next step is reviewing your terms and rates
          </p>
        </div>
        <div
          className={`${styles.button_container} ${styles.engineButtonContainer}`}
        >
          <NextButton
            text="Finalize my offer"
            styles={`${styles.button} ${styles.engineButton}`}
            variation="primary"
            type="button"
            buttonType="button"
            isArrow
            onClick={() =>
              openModal({
                name: MODAL_NAMES.engine,
                data: { prospect: prospect || null },
              })
            }
          />
        </div>
      </div>
    );
  }

  return (
    <>
      <PrismicNextLink
        field={page.data.button_link}
        className={styles.getInstantWrapper}
      >
        <IconTimer />
        <p className={styles.getInstantText}>
          Get instant offers in under 60 seconds
        </p>
      </PrismicNextLink>
      <div className={styles.button_container}>
        <Button
          link={page.data.button_link}
          text={page.data.button_text}
          styles={styles.button}
          variation="primary"
        />
      </div>
    </>
  );
};
